export default "CEE IND-UT / IND-BA 2026 — Primes CEE industrielles | Solution Éco France";
